import { Editor, Text } from "slate";
import { getSelection } from "../selectors";
function getValue(editor) {
  const matchingValues = Array.from(
    Editor.nodes(editor, {
      at: getSelection(editor),
      match: Text.isText
    })
  ).map(([node]) => node["typography"]);
  return matchingValues;
}
export {
  getValue
};
//# sourceMappingURL=getValue.js.map